/* facts-disclose.js · FACTS · Aufklapper, der nur auf einer Breite zuklappt
 * ------------------------------------------------------------------
 * <facts-disclose data-open-from="1020"> um eine Gruppe von <details>, die
 * ab der angegebenen Breite offen stehen und darunter zugeklappt sind.
 *
 * Warum ueberhaupt Skript: <details open> ist ein Attribut, keine
 * Medienabfrage. Rein mit CSS laesst sich derselbe Aufklapper nicht auf
 * einer Breite offen und auf der anderen geschlossen halten, ohne den
 * Inhalt zweimal ins Markup zu schreiben - und zwei Fassungen derselben
 * Copy sind eine Pflegefalle.
 *
 * Die Ausfallrichtung ist bewusst gewaehlt: im HTML steht `open`. Ohne
 * Javascript ist also alles AUFGEKLAPPT, und das ist der Zustand, den die
 * Seite vorher ohnehin hatte. Kaputt geht damit nichts, es fehlt nur die
 * Platzersparnis. Das Ruling vom 12.08. bleibt gewahrt: der Inhalt steht
 * im HTML und wird nie nachgeladen, hier wird ausschliesslich ein Attribut
 * umgelegt.
 *
 * Wer einen Aufklapper selbst angefasst hat, behaelt seinen Zustand, bis
 * die Breite wechselt. Das Skript ueberschreibt keine Handlung des Lesers.
 */
(function () {
  if (customElements.get('facts-disclose')) return;

  class FactsDisclose extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;

      this._items = [].slice.call(this.querySelectorAll('[data-disclose]'));
      if (!this._items.length) return;

      var from = parseInt(this.getAttribute('data-open-from'), 10);
      if (isNaN(from)) from = 1020;
      this._mq = window.matchMedia('(min-width:' + from + 'px)');

      this._apply = this._apply.bind(this);
      this._onToggle = this._onToggle.bind(this);
      this._quiet = false;

      var self = this;
      this._items.forEach(function (d) {
        d.addEventListener('toggle', self._onToggle);
      });

      this._apply();
      if (this._mq.addEventListener) this._mq.addEventListener('change', this._apply);
      else if (this._mq.addListener) this._mq.addListener(this._apply);
    }

    disconnectedCallback() {
      var self = this;
      if (this._items) {
        this._items.forEach(function (d) { d.removeEventListener('toggle', self._onToggle); });
      }
      if (this._mq) {
        if (this._mq.removeEventListener) this._mq.removeEventListener('change', this._apply);
        else if (this._mq.removeListener) this._mq.removeListener(this._apply);
      }
      this._on = false;
    }

    /* Nur eine Handlung des Lesers zaehlt, nicht das eigene Umlegen. */
    _onToggle(e) {
      if (this._quiet) return;
      e.currentTarget._touched = true;
    }

    _apply() {
      var wide = this._mq.matches;
      this._quiet = true;
      this._items.forEach(function (d) {
        if (wide) {
          d.open = true;
          d._touched = false;
        } else if (!d._touched) {
          d.open = false;
        }
      });
      /* Erst nach dem Stilrechnen wieder scharf schalten, sonst zaehlt das
         eigene Umlegen als Leserhandlung. */
      var self = this;
      requestAnimationFrame(function () { self._quiet = false; });
    }
  }

  customElements.define('facts-disclose', FactsDisclose);
})();
